// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IStateDto } from './IStateDto';
import {
    IStateDtoFromJSON,
    IStateDtoFromJSONTyped,
    IStateDtoToJSON,
    IStateDtoToJSONTyped,
} from './IStateDto';

/**
 * 
 * @export
 * @interface IOcrAddressResponseDto
 */
export interface IOcrAddressResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IOcrAddressResponseDto
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrAddressResponseDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrAddressResponseDto
     */
    city?: string;
    /**
     * 
     * @type {IStateDto}
     * @memberof IOcrAddressResponseDto
     */
    state?: IStateDto;
    /**
     * 
     * @type {string}
     * @memberof IOcrAddressResponseDto
     */
    zip?: string;
}

/**
 * Check if a given object implements the IOcrAddressResponseDto interface.
 */
export function instanceOfIOcrAddressResponseDto(value: object): value is IOcrAddressResponseDto {
    return true;
}

export function IOcrAddressResponseDtoFromJSON(json: any): IOcrAddressResponseDto {
    return IOcrAddressResponseDtoFromJSONTyped(json, false);
}

export function IOcrAddressResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrAddressResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'line1': json['line1'] == null ? undefined : json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : IStateDtoFromJSON(json['state']),
        'zip': json['zip'] == null ? undefined : json['zip'],
    };
}

export function IOcrAddressResponseDtoToJSON(json: any): IOcrAddressResponseDto {
    return IOcrAddressResponseDtoToJSONTyped(json, false);
}

export function IOcrAddressResponseDtoToJSONTyped(value?: IOcrAddressResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line1': value['line1'],
        'line2': value['line2'],
        'city': value['city'],
        'state': IStateDtoToJSON(value['state']),
        'zip': value['zip'],
    };
}

